import Bowser from 'bowser';
import { err, ok, type Result } from './result';

const regex = /Mobi|Android|iPhone|iPad|iPod/i;

export function isMobile() {
    return regex.test(navigator.userAgent);
}

export function isTouchDevice(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }

    return 'ontouchstart' in window || window.navigator.maxTouchPoints > 0;
}

export async function getGeoLocation(): Promise<Result<{ latitude: number; longitude: number }>> {
    if (!navigator.geolocation) {
        return err('Navegador não suporta geolocalização');
    }

    const promise: Promise<GeolocationPosition> = new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
    });

    try {
        const { coords } = await promise;
        return ok({ latitude: coords.latitude, longitude: coords.longitude });
    } catch {
        return err('Falha ao obter dados de geolocalização');
    }
}

export async function getIp(): Promise<Result<string>> {
    try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = (await response.json()) as { ip: string };
        return ok(data.ip);
    } catch {
        return err('Falha ao obter dados de IP');
    }
}

export function getPlatformInfo(): Bowser.Parser.ParsedResult {
    return Bowser.parse(window.navigator.userAgent);
}
